<article class="information-person">
    <section>
        <div class="row no-gutters content_top_margin">
            <div class="col-12 sectionHeadingMain">
                <ng-container *ngIf="!message">
                    <span *ngIf="preQualObj.flow_type==prequalType">{{'coflowstart.costart' | translate}} </span>
                    <span *ngIf="preQualObj.flow_type==switchType">{{'coflowstart.switchCoStart' | translate}} </span>
                </ng-container>
                <ng-container *ngIf="message">
                    {{'coapplicant-flow-start.message1' | translate }}<br />
                    {{'coapplicant-flow-start.message2' | translate }}
                </ng-container>
            </div>
        </div>
            <div class="row no-gutters top_height_actionButton content_top_mobile_margin">
                <div class="col-12  d-md-block d-flex  flex-column-reverse">
                    <cancel-button></cancel-button>
                    <button type="button" class="common_btn saveNextBtn_features space_between_button"
                        (click)="onContinue()">{{'buttonallpages.continuelable' | translate }}</button>
                </div>
            </div>

        <!-- <div class="row d-flex btnSave  buttonsView mr-md-3">
            <button type="button" class="mobile-view-btn buttonCommon saveNextBtn  mt-md-5" (click)="onContinue()">{{
                'buttonallpages.continuelable' | translate }}</button>

            <cancel-button class="cnc-fll cancelMargin"></cancel-button>
            <button type="button" class=" desktop-view-btn buttonCommon saveNextBtn ml-md-3 " (click)="onContinue()"
                aria-describedby="coApplicantInfo">{{
                'buttonallpages.continuelable' | translate }}</button>
        </div> -->


    </section>
</article>